import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  campaignDelete (params) {
    return axios.post(global.MMC_CAMPAIGN + '/market/deleteMarketCampaign', params)
  },
  campaignAdd (params) {
    return axios.post(global.MMC_CAMPAIGN + '/market/addMarketCampaign', params)
  },
  campaignUpdate (params) {
    return axios.post(global.MMC_CAMPAIGN + '/market/updateMarketCampaign', params)
  },
  campaignVerify (params) {
    return axios.post(global.MMC_CAMPAIGN + '/market/auditMarketCampaign', params)
  },
  findMarketCampaignStoreByCampaignId (params) {
    return axios.post(global.MMC_CAMPAIGN + '/market/findMarketCampaignStoreByCampaignId', params)
  },
  insertAdpic (params) { // 插入活动链接
    return axios.post(global.MMC_CAMPAIGN + '/adpic/insertAdpic', params)
  },
  updateAdpic (params) { // 更新活动链接
    return axios.post(global.MMC_CAMPAIGN + '/adpic/updateAdpic', params)
  }
}
// global.MMC_CAMPAIGN



// WEBPACK FOOTER //
// ./src/request/mmc/campaign.js